export default Object.freeze({
	ReadOnly: 'Account Contact Info (Read-Only)',
	RegularAdmin: 'Contact Info',
	LocationAdmin: 'Location Contact Info',
	CorporationAdmin: 'Corporate Contact Info',
});
